//
//  SDKCloudWarningType.ts
//  Supernova SDK
//
//  Created by Emir Bostanci.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Warning type type enum
export var ImportWarningType;
(function (ImportWarningType) {
    ImportWarningType["UnsupportedFill"] = "UnsupportedFill";
    ImportWarningType["UnsupportedStroke"] = "UnsupportedStroke";
    ImportWarningType["UnsupportedEffect"] = "UnsupportedEffect";
    ImportWarningType["StyleNotApplied"] = "StyleNotApplied";
    ImportWarningType["NoPublishedStyles"] = "NoPublishedStyles";
    ImportWarningType["NoPublishedComponents"] = "NoPublishedComponents";
    ImportWarningType["NoPublishedAssets"] = "NoPublishedAssets";
    ImportWarningType["NoVersionFound"] = "NoVersionFound";
    ImportWarningType["ComponentHasNoThumbnail"] = "ComponentHasNoThumbnail";
    ImportWarningType["DuplicateImportedStyleId"] = "DuplicateImportedStyleId";
    ImportWarningType["DuplicateImportedStylePath"] = "DuplicateImportedStylePath";
    ImportWarningType["NoPublishedElements"] = "NoPublishedElements";
    ImportWarningType["NoUnpublishedStyles"] = "NoUnpublishedStyles";
})(ImportWarningType || (ImportWarningType = {}));
